import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { LessonMeta } from '../../../typings';

export type GetLessonMetasResponse = Record<string, LessonMeta>;

export function getLessonMetas(slugs: string[]): Promise<GetLessonMetasResponse> {
    const { apiGetLessonMetas } = apiConfig.getStaticUrls();

    if(slugs.length === 0) {
        return Promise.resolve({});
    }

    return postFetch(apiGetLessonMetas, {
        slugs: slugs.join(','),
    });
}
